<template>
  <div class="dashboard-heading">
    <h1>{{ $t('MyBonusAccount') }}</h1>
  </div>
  <template v-if="!isLoading">
    <div class="tabs">
      <div class="layout">
        <ul class="tabs__list">
          <li class="tabs__item">
            <router-link class="tabs__item__link"
                         :to="{name: 'bonusBalance'}" active-class="link-active"
                         :class="{'link-active': $route.name === 'bonus'}">
              {{ $t('Balance') }}
            </router-link>
          </li>
          <li class="tabs__item">
            <router-link class="tabs__item__link"
                         :to="{name: 'bonusHistory'}" active-class="link-active">
              {{ $t('History') }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <template v-if="$route.name === 'bonusBalance' || $route.name === 'bonus'">
      <div class="bonus">
        <div class="bonus__value">{{ balance_amount }}</div>
        <div class="bonus__currency">₴</div>
      </div>
    </template>
    <template v-else-if="$route.name === 'bonusHistory'">
      <div class="transactions layout" v-if="transactions && transactions.length > 0">
        <ul class="transactions__items">
          <li class="transactions__items__item"
              v-for="transaction in transactions"
              :key="transaction.id">
            <div class="transactions__items__item__cell transactions__items__item__cell_main">
              <p class="transactions__items__item__cell__date">{{ transaction.created_format }}</p>
              <p class="transactions__items__item__cell__action"
                 :class="action_color(transaction.action) ? 'color-success' : 'color-alert'">
                {{ transaction.action_title }}
              </p>
            </div>
            <div class="transactions__items__item__cell">
              <p class="transactions__items__item__cell__status"
                 :class="status_color(transaction.status)">
                {{ transaction.status_title }}
              </p>
              <p class="transactions__items__item__cell__amount">
                <strong>{{ amount_symbol(transaction.action) ? '+' : '-' }}{{ transaction.amount }} ₴</strong>
              </p>
            </div>
            <div class="transactions__items__item__cell">
              <p class="transactions__items__item__cell__title">{{ $t('Order') }}</p>
              <template v-if="transaction.initiator === 1 && transaction.order !== null">
                <router-link class="transactions__items__item__cell__order"
                             :to="{name: 'order', params: {slug: transaction.order}}">
                  {{ transaction.order }}
                </router-link>
              </template>
              <template v-else>
                <p class="transactions__items__item__cell__order">{{ $t('ShoppingInOurChainOfStores') }}</p>
              </template>
            </div>
            <div class="transactions__items__item__cell">
              <p class="transactions__items__item__cell__comment">{{ transaction.comment }}</p>
            </div>
          </li>
        </ul>
        <div v-if="isMore" class="show-more" @click="getTransactions">
          <img :src="logoLoad" alt="load"/>
          {{ $t('ShowMore') }}
        </div>
      </div>
      <div class="transactionsEmpty" v-else>
        {{ $t('Empty') }}
      </div>
    </template>
  </template>
  <template v-if="isLoading">
    <div class="mt-10">
      <dashboard-local-preloader/>
    </div>
  </template>
</template>

<script>
import DashboardLocalPreloader from "@/components/LocalPreloader.vue"
import {mapGetters} from "vuex";
import {getterTypes, actionTypes, mutationTypes} from "@/store/modules/balance";


export default {
  name: 'DashboardBonus',
  components: {
    DashboardLocalPreloader,
  },
  data() {
    return {
      logoLoad: require('@/assets/svg/arrow-clockwise.svg'),
    }
  },
  mounted() {
    this.$store.commit(mutationTypes.clearTransactions)
    this.$store.dispatch(actionTypes.getBalance)
    this.$store.dispatch(actionTypes.getTransactions)
  },
  methods: {
    action_color(value) {
      return value === 1
    },
    status_color(value) {
      if (value === 2) {
        return 'color-success'
      } else if (value === 1) {
        return 'color-primary'
      } else {
        return 'color-alert'
      }
    },
    amount_symbol(value) {
      return value === 1
    },
    getTransactions(){
      return this.$store.dispatch(actionTypes.getTransactions)
    },
  },
  computed: {
    ...mapGetters({
      balance: getterTypes.balance,
      transactions: getterTypes.transactions,
      isLoading: getterTypes.isLoading,
      isMore: getterTypes.isMore,
    }),
    balance_amount() {
      if (!this.balance){
        return 0
      }
      return Math.trunc(this.balance.amount)
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";
  @import "@/scss/mixins.scss";

  p{
    margin-bottom: 0;
  }
  a{
    cursor: pointer;
    text-decoration: none;
  }
  ol, ul {
    list-style: none;
    padding: 0;
  }
  .pr-0{
    padding-right: 0;
  }
  .pl-0{
    padding-left: 0;
  }
  .dashboard-heading{
    margin-top: 20px;
  }
  .color-primary{
    color: $bb-90;
  }
  .color-alert{
    color: $danger;
  }
  .color-success{
    color: $success;
  }
  .color-default{
    color: $fd;
  }
  .color-inactive{
    color: $fi;
  }
  .bg-color-alert{
    background-color: $danger;
  }
  .bg-color-success{
    background-color: $success;
  }
  .bg-color-default{
    background-color: $fd;
  }
  .bg-color-blue{
    background-color: $bb-100;
  }
  .bg-color-inactive{
    background-color: $fi;
  }
  .layout{
    box-sizing: border-box;
    display: block;
    margin: 0 auto;
    max-width: 1600px;
    width: 100%;
    padding-left: 32px;
    padding-right: 32px;
  }
  .tabs{
    margin-bottom: 32px;
    position: relative;
    &__list{
      border-bottom: 1px solid #e9e9e9;
      display: flex;
      flex-direction: row;
      overflow: auto;
    }
    &__item{
      margin-right: 24px;
      &__link{
        color: $fd;
        display: inline-block;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
      }
    }
  }
  .link-active{
    box-shadow: inset 0 -2px 0 0 $success;
    color: $success;
  }
  .bonus{
    display: flex;
    justify-content: center;
    padding-top: 40px;
    &__value{
      color: $fi;
      font-size: 100px;
    }
    &__currency{
      color: $fi;
      align-items: flex-end;
      display: flex;
      padding-left: 10px;
      font-size: 34px;
      padding-bottom: 24px;
      opacity: 80%;
    }
  }
  .transactionsEmpty{
    display: flex;
    justify-content: center;
    padding: 25px;
  }
  .transactions{
    &__items{
      &__item{
        margin-top: 8px;
        display: flex;
        flex-direction: row;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        padding: 0;
        flex-wrap: nowrap;
        @media only screen and (max-width: $max-width-tablet-small) {
          flex-wrap: wrap;
        }
        &__cell_main{
          @media only screen and (max-width: $max-width-tablet-small) {
            width: 100% !important;
          }
        }
        &__cell{
          padding: 16px;
          flex: 1;
          width: auto;
          font-size: 14px;
          &__date{
            margin-bottom: 4px;
            font-size: 12px;
            color: #797878;
          }
          &__title{
            margin-bottom: 4px;
            font-size: 12px;
            color: #797878;
          }
          &__order{
            margin-bottom: 4px;
            font-size: 12px;
            color: #797878;
            font-weight: 800;
            cursor: pointer;
            &:hover{
              color: $fd;
            }
          }
          &__comment{
            margin-bottom: 4px;
            font-size: 12px;
            color: #797878;
          }
          &__amount{
            margin-bottom: 4px;
            font-size: 12px;
          }
        }
      }
    }
    .show-more{
      margin-top: 50px;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding-top: 24px;
      padding-bottom: 24px;
      cursor: pointer;
      color: $fd;
      font-weight: 900;
      img{
        width: 35px;
        height: 35px;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
  }
</style>
